module.exports = __webpack_public_path__ + "static/media/532.94bb19fb.png";